<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户审核</el-breadcrumb-item>
    </el-breadcrumb>
    <UserList :status="1"></UserList>
  </div>
</template>
<script>
import UserList from './list'
export default {
  components: {
    UserList,
  },
}
</script>